import { CreditCard } from 'lucide-react'
import { paymentAssets } from '../../../constants/assets'
import type { PaymentMethodKind } from '../../../types'

type Props = {
  method: PaymentMethodKind
  label: string
}

export const PaymentMethodCell = ({ method, label }: Props) => (
  <div className="flex items-end gap-[4px]">
    {method === 'paypal' && (
      <span className="flex h-[22px] w-[24px] shrink-0 items-center justify-center rounded-[4px] border-[0.75px] border-[#B7AFAF]">
        <img
          alt=""
          aria-hidden
          src={paymentAssets.paypal}
          className="h-[12px] w-[10px]"
        />
      </span>
    )}

    {method === 'credit-card' && (
      <span className="flex h-[22px] w-[24px] shrink-0 items-center justify-center">
        <CreditCard aria-hidden size={20} />
      </span>
    )}

    <span className="truncate font-host text-[14px] font-medium leading-normal text-black">
      {label}
    </span>
  </div>
)